import { Component, OnInit } from '@angular/core';
import * as highcharts from "highcharts";

@Component({
  selector: 'app-basicbar-chart',
  templateUrl: './basicbar-chart.component.html',
  styleUrls: ['./basicbar-chart.component.scss']
})
export class BasicbarChartComponent implements OnInit {
  chartOptions = {}
  highcharts = highcharts
  constructor() { }

  ngOnInit(): void {
    this.plotChart();
  }
  plotChart(){
    
    return this.chartOptions = {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
    },
    yAxis:{
      title:{
        enabled:false
      }
    },
      series: [{
        name: '',
        enabled: false,
        color: '#2A93FB',
        data: [8, 15, 10, 13, 7, 4]
      }]
    };
   
  }

}
